module.exports = __webpack_public_path__ + "img/animation-video-nikko-poster.cc24d17.jpg";